var _rect, _rect2, _rect3, _rect4, _rect5, _path, _rect6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 286,
    height: 373,
    viewBox: "0 0 286 373",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 223,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 252,
    width: 14,
    height: 51,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 289,
    width: 103,
    height: 14,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    width: 14,
    height: 100,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 214.614,
    y: 208.8,
    width: 14,
    height: 108.772,
    transform: "rotate(-30 214.614 208.8)",
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.502 0L197.473 1.8457L207.886 4.8877L217.946 9.09766L227.502 14.4043L236.465 20.749L244.736 28.0498L244.979 28.3154L252.225 36.2129L258.672 44.8926L258.675 44.8945L258.87 45.1572L259.036 45.4385L264.599 54.7744L269.36 64.96L273.111 75.6123L273.185 75.9053L275.818 86.626L275.864 86.9316L278 99.3516V109.161L277.451 120.574L275.861 131.525L275.818 131.808L273.185 142.529L273.111 142.82L273.017 143.094L269.359 153.476L264.599 163.659L258.869 173.276L252.229 182.216L251.992 182.476L244.735 190.385L236.465 197.685L227.508 204.025L217.946 209.336L207.886 213.546L197.448 216.595L186.744 218.443L177.003 219H168V206.376L184.874 205.412L193.764 203.878L202.475 201.334L210.939 197.791L219.054 193.283L226.717 187.859L233.872 181.544L240.397 174.431L246.236 166.571L251.313 158.051L255.552 148.983L258.911 139.445L261.34 129.561L262.811 119.441L263.302 109.217L262.811 98.9922L261.34 88.8721L258.911 78.9883L255.552 69.4502L251.313 60.3828L246.241 51.8662L240.397 44.0029L233.872 36.8896L226.717 30.5742L219.054 25.1494L210.939 20.6426L202.475 17.0996L193.764 14.5547L184.874 13.0205L168 12.0566V0H184.502Z",
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 206.4,
    width: 12,
    height: 12.6,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLr);
export default __webpack_public_path__ + "static/media/lr.c8b838ed4e37e92c7da42a22550c4398.svg";
export { ForwardRef as ReactComponent };